import React from "react";
import { RichText as RichTextConverter } from "@payloadcms/richtext-lexical/react";

export const renderRichTextAsHTML = (
  richText: any,
  isDescription?: boolean,
  textColor?: string,
  className?: string
) => {
  if (typeof richText === "string") {
    if (richText.includes("<b>") || richText.includes("<strong>")) {
      return <span dangerouslySetInnerHTML={{ __html: richText }} />;
    }
    return <span>{richText}</span>;
  }

  if (!richText?.root?.children?.[0]?.children) return "";

  const elements = richText.root.children[0].children.map(
    (textNode: any, index: number) => {
      if (textNode.format === 1) {
        return <span className={` ${textColor} text-xl-bold text-neutral-900 md:text-2xl-bold xl:text-3xl-bold`} key={index}>{textNode.text}</span>;
      } else {
        return (
          <span
            className={`${
              !isDescription &&
              "text-xl-light text-neutral-900 md:text-2xl-light md:max-w-[90%] xl:text-3xl-light "
            } ${textColor} ${className}`}
            key={index}
          >
            {textNode.text}
          </span>
        );
      }
    }
  );

  return <>{elements}</>;
};

export function Note({
  title,
  description,
  titleEffectStyle,
}: {
  title: any;
  description?: string;
  titleEffectStyle?: string;
}) {
  const gradientColor =
    titleEffectStyle === "secondary" ? "#E16F60" : "#F1F6F3";
  const textColor =
    titleEffectStyle === "secondary" ? "text-white" : "text-neutral-900";

  return (
    <div>
      <div>
        <div
          className={`text-xl-regular md:text-2xl-regular md:max-w-[90%] ${textColor} bg-no-repeat bg-[length:100%_50%] bg-top`}
          style={{
            display: "inline",
            boxDecorationBreak: "clone",
            WebkitBoxDecorationBreak: "clone",
            backgroundImage: `linear-gradient(to bottom,${gradientColor},${gradientColor})`,
          }}
        >
          {(() => {
            if (typeof title === "string") {
              if (title.includes("<b>") || title.includes("<strong>")) {
                return <span dangerouslySetInnerHTML={{ __html: title }} />;
              }
              return <span>{title}</span>;
            }

            if (!title?.root?.children?.[0]?.children) return "";

            const elements = title.root.children[0].children.map(
              (textNode: any, index: number) => {
                if (textNode.format === 1) {
                  return <span className={`${textColor} text-xl-bold text-neutral-900 md:text-2xl-bold`} key={index}>{textNode.text}</span>;
                } else {
                  return (
                    <span
                      className={`text-xl-light text-neutral-900 md:text-2xl-light md:max-w-[90%] ${textColor}`}
                      key={index}
                    >
                      {textNode.text}
                    </span>
                  );
                }
              }
            );

            return <>{elements}</>;
          })()}
        </div>
        {description && (
          <RichTextConverter
            className="text-m-regular text-neutral-900"
            data={description as any}
          />
        )}
      </div>
    </div>
  );
}
